import { Button } from 'reactstrap'
import styles from './Header.module.css'
import person from '../images/person.svg'
import { useLocation } from 'react-router-dom'
import { Grow } from '@mui/material'
import infoIcon from '../images/info.svg'
import { AutoHyperlink } from './AutoHyperlink'
import { logoutAppLegacy, logoutPlatformLegacy, useWistorAuth } from '../api/auth'
import {useHistory} from 'react-router-dom'

const BACKUP_LOGO = '/logos/logo-wistor.png'

type Props = CommonProps & ({} | ViewerProps)

type CommonProps = {
  modern?: boolean
  noLoginButton?: boolean
}

type ViewerProps = {
  title: string
  subtitle: string
  repoURL: string
  localRepoURL?: string
  bbsparqlendpoint: string
  pageWidth?: string
  logoURL?: string
  parseUrlProperties?: boolean
  logoutbutton?: boolean
  onInfoClick?: () => void
}

export function Header(props: Props) {
  const auth = useWistorAuth()
  const history = useHistory()
  const location = useLocation()

  const logoutRepoAndOrPlatform = async () => {
    const logoutPromises: Promise<void>[] = []
    let reloadAfterPromise = true
    if (auth.isAuthenticated && auth.isSingleLogin) {
      logoutPromises.push(auth.logout())
      reloadAfterPromise = false
    }
    if ('bbsparqlendpoint' in props && props.bbsparqlendpoint != null) {
      logoutPromises.push(logoutAppLegacy(props.repoURL))
    } else {
      logoutPlatformLegacy()
    }
    await Promise.all(logoutPromises)
    if (reloadAfterPromise) window.location.reload()
  }

  const login = () => history.push('/login', location.pathname)

  const onClickManageUsers = () => history.push('/users', location.pathname)

  const logoutbutton = 'logoutbutton' in props ? props.logoutbutton : false

  const showLogoutButton = auth.isAuthenticated || logoutbutton

    const showLoginButton = auth.isAuthenticated
      && !showLogoutButton
      && !props.noLoginButton

    return (
      <Grow appear timeout={1000} in={true}>
        <div className={`${styles.wrapper} ${props.modern ? styles.modern : ''}`}>
          <div
            className={styles.main}
            style={{ maxWidth: 'pageWidth' in props ? props.pageWidth : undefined }}
          >
            <img
              src={'logoURL' in props ? props.logoURL : BACKUP_LOGO}
              alt="logo"
              style={{ maxHeight: '40px', marginRight: '6px' }}
            />

            <div className={styles.centerPart}>
              <span className={styles.title}>
                {'title' in props ? props.title : ''}
                {'onInfoClick' in props && props.onInfoClick && (
                  <img
                    src={infoIcon}
                    alt="box"
                    className={styles.infoIcon}
                    onClick={props.onInfoClick}
                  />
                )}
              </span>
              <AutoHyperlink text={'subtitle' in props ? props.subtitle : ''} />
            </div>
            <div className={styles.auth}>
              {auth.status === 'authorized' && (
                  <>
                    <img src={person} alt="person" />
                    <div className={styles.nameContainer}>
                      <div style={{ lineHeight: '1.1em' }}>
                        {auth.user.name}
                      </div>
                      {(auth.user.role === 'admin' || auth.user.role === 'superadmin') && (
                        <Button
                          color="link"
                          style={{ padding: '0', fontSize: '0.8em' }}
                          onClick={onClickManageUsers}
                        >
                          Manage Users
                        </Button>
                      )}
                    </div>
                  </>
              )}
              {showLogoutButton && (
                <Button color="link" onClick={logoutRepoAndOrPlatform}>
                  Log out
                </Button>
              )}
              {showLoginButton && (
                <Button color="primary" onClick={login}>
                  Login
                </Button>
              )}
            </div>
          </div>
        </div>
      </Grow>
    )
}
